// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  width: 100%;
  min-height: 74px;
  display: grid;
  grid-template-columns: 20% auto 20%;
  align-items: center;
  justify-items: center;
  margin: 0 auto;
  box-sizing: border-box;
  padding: 10px 40px;
  position: fixed;
  z-index: 900;
  background-color: #fcfdfd;
}

.header__logo {
  height: 45px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
}

.header__logo:hover {
  color: #073042;
  background-color: #f0f0f0;
  background-size: cover;
  background-position: center;
}

.header__logo img {
  width: 100%;
  max-height: 74px;
}

.header__name h1 {
  font-family: Oswald-Light, sans-serif;
  font-weight: 400;
  font-size: 38px;
  max-width: 100%;
  margin: 0;
}

.header__contacts {
  display: flex;
  flex-direction: column;
  gap: 7px;
  align-items: end;
}

.header__list {
  display: flex;
  justify-content: center;
  align-items: center;
  list-style-type: none;
  padding: 0;
  gap: 20px;
  margin: 0;
}

.header__phone-block {
  display: flex;
  align-items: center;
  gap: 7px;
  margin: 0;
}

.header__phone {
  font-family: Oswald-Light, sans-serif;
  font-size: 20px;
  margin: 0;
}

@media screen and (max-width: 769px) {
  .header {
    grid-template-columns: 20% auto 20%;
    grid-template-rows: 60% 20% 20%;
    grid-template-areas:
      "logo name ."
      ". contacts ."
      ". . .";
  }

  .header__logo {
    grid-area: logo;
  }

  .header__contacts {
    flex-direction: row-reverse;
    gap: 30px;
    grid-area: contacts;
  }

  .header__name h1 {
    font-size: 24px;
    grid-area: name;
  }
  .header__phone {
    font-size: 18px;
  }

  .header__contacts {
    gap: 15px;
  }
  .header__list {
    gap: 13px;
  }
}

@media screen and (max-width: 494px) {
  .header {
    grid-template-columns: 15% auto 15%;
  }

  .header__name h1 {
    font-size: 16px;
  }
  .header__phone {
    font-size: 14px;
  }

  .header__contacts {
    gap: 10px;
  }
  .header__list {
    gap: 10px;
  }
  .header__phone-block img {
    max-height: 14px;
  }

  .header__icon img {
    max-height: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Header/Header.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mCAAmC;EACnC,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,UAAU;EACV,SAAS;EACT,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,SAAS;AACX;;AAEA;EACE;IACE,mCAAmC;IACnC,+BAA+B;IAC/B;;;aAGS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,2BAA2B;IAC3B,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;EACA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;EACA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,mCAAmC;EACrC;;EAEA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;EACA;IACE,SAAS;EACX;EACA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".header {\n  width: 100%;\n  min-height: 74px;\n  display: grid;\n  grid-template-columns: 20% auto 20%;\n  align-items: center;\n  justify-items: center;\n  margin: 0 auto;\n  box-sizing: border-box;\n  padding: 10px 40px;\n  position: fixed;\n  z-index: 900;\n  background-color: #fcfdfd;\n}\n\n.header__logo {\n  height: 45px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-decoration: none;\n}\n\n.header__logo:hover {\n  color: #073042;\n  background-color: #f0f0f0;\n  background-size: cover;\n  background-position: center;\n}\n\n.header__logo img {\n  width: 100%;\n  max-height: 74px;\n}\n\n.header__name h1 {\n  font-family: Oswald-Light, sans-serif;\n  font-weight: 400;\n  font-size: 38px;\n  max-width: 100%;\n  margin: 0;\n}\n\n.header__contacts {\n  display: flex;\n  flex-direction: column;\n  gap: 7px;\n  align-items: end;\n}\n\n.header__list {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  list-style-type: none;\n  padding: 0;\n  gap: 20px;\n  margin: 0;\n}\n\n.header__phone-block {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  margin: 0;\n}\n\n.header__phone {\n  font-family: Oswald-Light, sans-serif;\n  font-size: 20px;\n  margin: 0;\n}\n\n@media screen and (max-width: 769px) {\n  .header {\n    grid-template-columns: 20% auto 20%;\n    grid-template-rows: 60% 20% 20%;\n    grid-template-areas:\n      \"logo name .\"\n      \". contacts .\"\n      \". . .\";\n  }\n\n  .header__logo {\n    grid-area: logo;\n  }\n\n  .header__contacts {\n    flex-direction: row-reverse;\n    gap: 30px;\n    grid-area: contacts;\n  }\n\n  .header__name h1 {\n    font-size: 24px;\n    grid-area: name;\n  }\n  .header__phone {\n    font-size: 18px;\n  }\n\n  .header__contacts {\n    gap: 15px;\n  }\n  .header__list {\n    gap: 13px;\n  }\n}\n\n@media screen and (max-width: 494px) {\n  .header {\n    grid-template-columns: 15% auto 15%;\n  }\n\n  .header__name h1 {\n    font-size: 16px;\n  }\n  .header__phone {\n    font-size: 14px;\n  }\n\n  .header__contacts {\n    gap: 10px;\n  }\n  .header__list {\n    gap: 10px;\n  }\n  .header__phone-block img {\n    max-height: 14px;\n  }\n\n  .header__icon img {\n    max-height: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
